export type RegistrationValues = { email: string; name: string; phone: string; password: string; confirmPassword: string };
export type RegistrationErrors = Partial<Record<keyof RegistrationValues, string>>;

export function validateRegistration(values: RegistrationValues): RegistrationErrors {
  const errors: RegistrationErrors = {};
  if (!values.email.trim()) errors.email = "Informe seu e-mail.";
  else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email.trim())) errors.email = "Informe um e-mail válido.";
  if (!values.name.trim()) errors.name = "Informe seu nome.";
  else if (values.name.trim().length > 255) errors.name = "O nome deve ter no máximo 255 caracteres.";
  if (!values.phone.replace(/\D/g, "")) errors.phone = "Informe seu telefone.";
  if (!values.password) errors.password = "Crie uma senha.";
  else if (values.password.length < 8) errors.password = "A senha deve ter pelo menos 8 caracteres.";
  if (!values.confirmPassword) errors.confirmPassword = "Confirme sua senha.";
  else if (values.confirmPassword !== values.password) errors.confirmPassword = "As senhas não coincidem.";
  return errors;
}

export function registrationFailure(error: any): { message: string; fields: RegistrationErrors } {
  const status = error?.response?.status;
  const fields: RegistrationErrors = {};
  if (status === 400 || status === 422) {
    const details = error?.response?.data?.errors;
    if (Array.isArray(details)) for (const detail of details) {
      if (typeof detail !== "string") continue;
      if (/^senha\b/i.test(detail)) fields.password = "A senha deve ter pelo menos 8 caracteres.";
      if (/^email\b/i.test(detail)) fields.email = "Informe um e-mail válido.";
      if (/^nome_completo\b/i.test(detail)) fields.name = "Informe um nome de até 255 caracteres.";
      if (/^telefone\b/i.test(detail)) fields.phone = "Informe seu telefone corretamente.";
    }
    if (error?.response?.data?.message === "E-mail já está em uso.") {
      fields.email = "Este e-mail já está cadastrado. Entre na sua conta ou recupere sua senha.";
    }
    return { fields, message: Object.keys(fields).length ? "Revise os campos destacados para concluir o cadastro." : "Não foi possível validar o cadastro. Confira os dados informados e tente novamente." };
  }
  if (status === 429 || error?.isRateLimited) return { fields, message: "Muitas tentativas de cadastro. Aguarde alguns minutos antes de tentar novamente." };
  if (["ECONNABORTED", "ETIMEDOUT"].includes(error?.code)) return { fields, message: "O servidor demorou para responder. Tente novamente em instantes." };
  if (!error?.response && (error?.isAxiosError || error?.code === "ERR_NETWORK")) return { fields, message: "Não foi possível conectar ao servidor. Verifique sua conexão e tente novamente." };
  return { fields, message: "Não foi possível concluir o cadastro agora. Tente novamente em instantes. Se o problema continuar, entre em contato com insecta@ufrb.edu.br." };
}
